import { z } from "zod";
import { ENDING_RARITY_VALUES } from "../../constants/ending-rarity.js";
export const UnlockedEndingSchema = z.object({
    endingId: z.uuid(),
    storyId: z.uuid(),
    name: z.string(),
    number: z.number().int().positive(),
    rarity: z.enum(ENDING_RARITY_VALUES),
    unlockedPercent: z.number().min(0).max(100),
    unlockedAt: z.string(),
});
